import { render, staticRenderFns } from "./item.vue?vue&type=template&id=22f2cc10&scoped=true&"
import script from "./item.vue?vue&type=script&lang=ts&"
export * from "./item.vue?vue&type=script&lang=ts&"
import style0 from "./item.vue?vue&type=style&index=0&id=22f2cc10&lang=scss&scoped=true&"
import style1 from "./item.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f2cc10",
  null
  
)

export default component.exports